import V2ModalForm from "components/ModalForm/V2ModalForm";
import { Meeting, MeetingId } from "features/Resources/Meeting/models";
import { useMeetingDetailQuery } from "features/Resources/Meeting/hooks";
import ScheduleOrSelectMeetingSteps from "features/Resources/Meeting/Components/ScheduleOrSelectMeetingSteps";
import GroupSessionRescheduleOptions from "features/Resources/Meeting/Components/GroupSessionRescheduleOptions";
import { BaseScheduleTableButton } from "./BaseScheduleButton";
import { Text12 } from "components/Text";
import { meetingStartEnd } from "helpers/time";
import { Button } from "@chakra-ui/react";

interface GroupSchedulingButtonBaseProps {
  meetingId: MeetingId;
  renderButton: (onOpen: () => void) => React.ReactNode;
}

export function GroupSchedulingButtonBase({ meetingId, renderButton }: GroupSchedulingButtonBaseProps) {
  const { data: meeting } = useMeetingDetailQuery(meetingId);

  const isScheduled = meeting?.status === "scheduled";
  const modalHeader = meeting
    ? isScheduled
      ? `Reschedule ${meeting.name}`
      : `Schedule ${meeting.name}`
    : "Schedule Meeting";

  return (
    <V2ModalForm
      modalHeader={modalHeader}
      size="2xl"
      closeOnOverlayClick
      includeCloseButton={false}
      renderButton={renderButton}
      renderForm={(onClose) => {
        if (!meeting) return null;
        return isScheduled ? (
          <GroupSessionRescheduleOptions meetingId={meeting.id} onClose={onClose} />
        ) : (
          <ScheduleOrSelectMeetingSteps meetingId={meeting.id} onClose={onClose} />
        );
      }}
    />
  );
}

interface GroupSchedulingTableButtonProps {
  meeting: Meeting;
}

export function GroupSchedulingTableButton({ meeting }: GroupSchedulingTableButtonProps) {
  if (!meeting || ["removed", "skipped", "cancelled"].includes(meeting?.status)) {
    return null;
  }
  return (
    <GroupSchedulingButtonBase
      renderButton={(onOpen) => {
        return meeting.status === "pending_scheduling" ? (
          <BaseScheduleTableButton onClick={onOpen} />
        ) : (
          <Button variant="unstyled" onClick={onOpen}>
            <Text12>{meetingStartEnd(meeting.startTime, meeting.endTime)}</Text12>
          </Button>
        );
      }}
      meetingId={meeting.id}
    />
  );
}
